<template>
  <div>
  </div>
</template>
<script>
import { toPairs, debounce, isEqual } from 'lodash';

let num = 0;
let globalHistory = {}
let EXISTING_DATA = {};
let VUE_ROUTER;
let VUE_ROUTE;


let pushes = [];
function _pushGlobalHistory() {
  const data = {...EXISTING_DATA};
  pushes.forEach( ([key,value,empty]) => {
    if (value && value !== "false" && value !== JSON.stringify(empty)) {
      data[key] = value;
    } else if (value !== "false") {
      if (value === JSON.stringify(empty)) {
        if (typeof(data[key]) !== 'undefined') {
          data[key] = value;
        }
      }
    }
  });
  //console.log('data', JSON.stringify(data,0,2));
  VUE_ROUTER.push({
    //query:{...data, num},
    query:{...data},
  }).catch(err => {
    // Ignore the err regarding  navigating to the page they are already on.
    if (
      err.name !== 'NavigationDuplicated' &&
      !err.message.includes('Avoided redundant navigation to current location')
    ) {
      // But print any other errors to the console
      console.error(err);
      throw err;
    }
  });;
  num++;
  pushes = [];
}

const pushGlobalHistory = debounce(_pushGlobalHistory, 200);


function pushHistory($route, name, data, empty) {
  EXISTING_DATA = $route.query;
  pushes.push([name, JSON.stringify(data), empty]);
  pushGlobalHistory();
}


export default {
  props: {
    value: {
      type: [Object,Array,String, Boolean],
      default: undefined
    },
    name: {
      type: String,
      default: 'default'
    },
    empty: {
      default: undefined
    }
  },
  data() {
    return {
      pushValue:debounce(this._pushValue, 0),
      first: true,
    }
  },
  methods: {
    handlePopState({state}) {
    },
    _pushValue() {
      if (process.browser) {
        pushHistory(this.$route, this.name, this.value, this.empty);
      }
    }
  },
  mounted() {
    if (process.browser) {
      window.addEventListener('popstate', this.handlePopState);
      VUE_ROUTER = this.$router;
      VUE_ROUTE = this.$route;
    }
  },
  beforeDestroy() {
    if (process.browser) {
      window.removeEventListener('popstate', this.handlePopState);
    }
  },
  watch:{
    value: {
      handler(nv) {
        if (!isEqual(nv, this.block)) {
          this.pushValue();
          this.block = undefined;
        }
      },
      immediate: true
    },
    historyData(nv) {
      if (!process.browser) {
        return;
      }
      if (typeof(nv) !== 'undefined') {
        const data = JSON.parse(nv);
        //this.$emit('pop-state', {name:this.name, data});
        this.block = data;
        this.$emit('input', data);
        this.$emit('change', data);
      } else {
        if (typeof(this.empty) === 'undefined') {
          const data = undefined;
          this.block = undefined;
          this.$emit('input', data);
          this.$emit('change', data);
        } else {
          this.$emit('input', this.empty);
          this.$emit('change', this.empty);
        }
      }
    }
  },
  computed: {
    historyData() {
      return this.$route.query[this.name];
    }
  }
}
</script>
